import React, {Component} from 'react';
import CapabilityContextProvider from "../global/context/CapabilityContext";
import DepartContextProvider from "./context/DepartContext";
import DepartView from "./DepartView";
import DepartFilterContextProvider from "./context/DepartFilterContext";

class Depart extends Component {

    render() {
        return (
            <CapabilityContextProvider>
                <DepartFilterContextProvider context={this.props.match.params.context}>
                    <DepartContextProvider>
                        <DepartView/>
                    </DepartContextProvider>
                </DepartFilterContextProvider>
            </CapabilityContextProvider>
        )
    }
}

export default Depart


// WEBPACK FOOTER //
// ./src/components/depart/Depart.js